// SAN Security departments — mirrors EMPLOYEE_PORTAL_DEPARTMENTS in core/security.py.
export const DEPARTMENTS = [
  { slug: 'operations', name: 'Operations' },
  { slug: 'control-room', name: 'Control Room' },
  { slug: 'payroll', name: 'Payroll' },
  { slug: 'hr-compliance', name: 'HR & Compliance' },
  { slug: 'recruitment-onboarding', name: 'Recruitment & Onboarding' },
  { slug: 'client-management', name: 'Client Management' },
  { slug: 'quality-audit', name: 'Quality & Audit' },
];

const NO_SUFFIX = new Set(['control room']);

export const deptDisplay = (name) => {
  const d = (name || '').trim();
  if (!d) return '';
  return NO_SUFFIX.has(d.toLowerCase()) ? d.toUpperCase() : `${d.toUpperCase()} DEPARTMENT`;
};

export const deptBySlug = (slug) => DEPARTMENTS.find((d) => d.slug === slug) || null;
